import { apiV2 } from '../services';
export const listRecentWinners = async () => {
    const res = await apiV2.rewardHub.listRecentWinners();
    if (res.status === 200) {
        return res.body;
    }
    else {
        // handle error here
        throw new Error('getLeaderboard error');
    }
};
export const getUserInformation = async () => {
    const res = await apiV2.rewardHub.getUserInformation();
    if (res.status === 200) {
        return res.body;
    }
    else {
        // handle error here
        throw new Error('getUserInformation error');
    }
};
export const openLootbox = async (type) => {
    const res = await apiV2.rewardHub.openLootbox({
        body: {
            type,
        },
    });
    if (res.status === 200) {
        return res.body;
    }
    else {
        throw new Error('openLootbox error');
    }
};
